export const LOADING = 'LOADING';
export const FECTHING_PAYMENT_HISTORY_SUCCESS = 'FECTHING_PAYMENT_HISTORY_SUCCESS';
export const FETCHING_BY_ORDER_ID = 'FETCHING_BY_ORDER_ID';
export const UNPAID_REMITTANCE_ORDER = 'UNPAID_REMITTANCE_ORDER';
export const REMITTANCE_METRICS = 'REMITTANCE_METRICS';
export const FETCHING_DETAILS_BY_ORDER_ID = 'FETCHING_DETAILS_BY_ORDER_ID';
